export default "__VITE_ASSET__DH_oztRT__"